import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import type { SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'bg-site-neutrals-900 text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'border-current'],
  [SiteVariantEnum.Tertiary, 'text-site-neutrals-900'],
  [SiteVariantEnum.TextOnly, 'text-site-neutrals-900'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'hover:bg-site-neutrals-700'],
  [SiteVariantEnum.Secondary, 'hover:bg-site-neutrals-900 hover:border-site-neutrals-900'],
  [SiteVariantEnum.Tertiary, 'hover:text-site-neutrals-700'],
  [SiteVariantEnum.TextOnly, 'hover:text-site-neutrals-700'],
]);

const buttonShadowClasses = 'focus:shadow-site-primary-50';

/**
 * Site Theme / Black Light Button Color Variant
 */

const buttonSiteBlackLightTheme = (_size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [buttonClassesMap, buttonHoverClassesMap],
  buttonSiteVariantColorShadowClasses: buttonShadowClasses,
});

export default buttonSiteBlackLightTheme;
